import { template as template_4b001af43708436d83feac30c36e5dc9 } from "@ember/template-compiler";
import Component from '@glimmer/component';
import styles from './filtered-results-summary.module.scss';
import t from 'ember-intl/helpers/t';
const LOCALE_PREFIX = 'booking.clinicianSearch.filteredResults';
export default class RequestClinicianSearchFilteredResultsSummary extends Component {
    styles = styles;
    get summary() {
        return this.args.meta?.summary ?? {};
    }
    get isCapped() {
        return !!this.summary.showCappedFilteredResults;
    }
    get type() {
        return this.isCapped ? 'Capped' : 'Exact';
    }
    get count() {
        let { filteredResultsCappedCount, fullClinicianCount } = this.summary;
        return this.isCapped ? filteredResultsCappedCount : fullClinicianCount;
    }
    get prefixKey() {
        return `${LOCALE_PREFIX}${this.type}Prefix`;
    }
    get countKey() {
        return `${LOCALE_PREFIX}${this.type}Count`;
    }
    static{
        template_4b001af43708436d83feac30c36e5dc9(`
    {{#unless @isLoading}}
      <div class={{styles.component}} role="status" ...attributes>
        <span class="summary-prefix" data-test-clinician-search-summary-prefix>
          {{t this.prefixKey}}
        </span>
        <span class="summary-count" data-test-clinician-search-summary-count>
          {{t this.countKey count=this.count}}
        </span>
      </div>
    {{/unless}}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
